// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"ro-z","imageAndVideoCount":"so-z","imageAndVideoContainer":"to-z","viewAllReviews":"uo-z"};